<mat-toolbar class="header">
  <mat-toolbar-row class="header" fxLayout="row">
    <a mat-button routerLink="">
      <img class="logo" src="assets/img/cc-logo.png"/>
    </a>

    <div fxFlex></div>

    <div *ngIf="user && !user.isTotpActive">
      <span style="background-color: orange; font-size: .7em; border-radius: 5px; padding: 3px 6px; cursor: pointer;" (click)="goToSetupTotp()">
        <mat-icon style="font-size: .8em; margin: 0; padding: 0; height: auto; width: auto;">security</mat-icon> Action needed
      </span>

    </div>

    <!--<div *ngIf="user && user.roleGroup" style="margin-right: 10px;">
      <span style="font-size: .7em;">
        {{user.roleGroup}}
      </span>

    </div>-->

    <div *ngIf="user && user.isTotpActive">
      <span style="color: forestgreen; text-align: center">
        <mat-icon style="font-size: .8em; margin: 0; height: auto; width: auto;">security</mat-icon>
      </span>

    </div>

    <button mat-button [matMenuTriggerFor]="menu" fxFlex="none">
      <ng-container *ngIf="user">
        <mat-icon *ngIf="!showLogo">account_circle</mat-icon>
        <img *ngIf="showLogo" src="{{user.logoUrl}}" class="user-logo">
        <span>{{user.firstName}} {{user.lastName}}</span>
      </ng-container>
    </button>

    <mat-menu #menu="matMenu" [overlapTrigger]="false">
      <a mat-menu-item [routerLink]="'/my-account'">
        <mat-icon>account_box</mat-icon>
        <span>My account</span>
      </a>
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
